import api from 'api/apiInstance';

export function adviceRoomCanUseApi(path: string) {
  return {
    path,
    GET: () => api.get(path),
  };
}
